// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { isUserInPhoneOnlyTest } from '@ltvco/refresh-lib/utils';
import {
  MonitoringOverview,
  useSession,
  useSriracha,
} from '@ltvco/refresh-lib/v1';
import {
  FeatureBlockedModal,
  useFeatureBlockedModal,
} from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';

import { constants } from 'appConstants';
// END IMPORTS

export function Monitoring() {
  // START HOOKS_AND_QUERIES
  const { data } = useSriracha();
  const {
    isFeatureBlockedModalOpen,
    closeFeatureBlockedModal,
    openFeatureBlockedModal,
  } = useFeatureBlockedModal();
  const { isBlocked, phoneOnlyVariation } =
    useSubscriptionAccessConfigContext();

  const {
    session: { account },
  } = useSession();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [searchType, setSearchType] = useState('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);
  const [customCTAPublishEvent, setCustomCTAPublishEvent] =
    useState<string>('');
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const notifications = data || [];

  const peopleSearchBlocked = isBlocked('person');

  const { phoneOnlyPlanNames } = constants;
  const isPhoneOnlyVariation =
    isUserInPhoneOnlyTest(account, phoneOnlyPlanNames) || phoneOnlyVariation;
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (isPhoneOnlyVariation) {
      setCustomCTAPublishEvent('openPhoneSearch');
    } else {
      setCustomCTAPublishEvent('');
    }
  }, [isPhoneOnlyVariation]);
  // END EFFECTS

  // START EVENT_HANDLERS
  const onClickHandler = () => {
    if (peopleSearchBlocked) {
      setSearchType('People');
      openFeatureBlockedModal();
    }
  };
  // END EVENT_HANDLERS

  // START RENDER
  return (
    <>
      <MonitoringOverview
        notifications={notifications}
        onClickHandler={onClickHandler}
        searchBlocked={peopleSearchBlocked}
        customCTAPublishEvent={customCTAPublishEvent}
      />
      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </>
  );
  // END RENDER
}
